// extracted by mini-css-extract-plugin
export default {"root":"story-layout_root__YD74x"};